import { Toast } from 'react-hot-toast';
import './styles/toast.css';
import { Check, CircleAlert, Star } from 'lucide-react';

type CustomToastProps = {
  t: Toast;
  message: string;
  success?: boolean;
  star?: boolean;
  warning?: boolean;
};

function CustomToast(props: CustomToastProps) {
  const { t, message, success, star, warning } = props;
  return (
    <div className={`custom-toast ${t.visible ? 'animate-enter' : 'animate-leave'}`}>
      {success && (
        <span className="toast-success-icon">
          <Check />
        </span>
      )}
      {star && <Star className="toast-star-icon" />}
      {warning && <CircleAlert className="toast-alert-icon" />}
      <span className="custom-toast-message">{message}</span>
    </div>
  );
}

export default CustomToast;
